import { nav } from './nav';

export function setupPageLoadAnimation() {
    /*
        RP, TODO: Listen for cookie information necessary cookies. When they are accepted we want to run the animation.
        RP, TODO: The animation elements have to be created dynamically based on the cookie information necessary accepted.
                  We don't want to have the overlay when cookie information is somehow not loaded.
                  This way we dont show the overlay and never remove it when there's an error in cookieinformation etc.
        RP, TODO: This might be helpful: https: //support.cookieinformation.com/hc/en-us/articles/360017912412-3-3-Cookie-Control-SDK-and-Inline-script
    */

    const windowHeight = window.innerHeight;
    const pageLoadElm = document.querySelector('.page-loading-animation');
    const logoLine = document.querySelector('.page-loading-animation__line');

    function endAnimation() {
        // Let's remove the eventlistener. We've heard what we've been listening for. We cover our ears for now :-)
        nav.removeEventListener('transitionend', endAnimation);

        document.body.classList.add('js-loaded');
        document.body.classList.remove('js-load--step1');
        document.body.classList.remove('js-load--step2');
        document.body.classList.remove('js-load--step3');
        document.body.classList.remove('js-load');

        setTimeout(function() {
            document.body.classList.remove('js-loaded');
        },5);
    }

    function startContentAnimation() {
        // Let's remove the eventlistener. We've heard what we've been listening for. We cover our ears for now :-)
        logoLine.removeEventListener('transitionend', startContentAnimation);

        nav.addEventListener('transitionend',endAnimation);
        document.body.classList.add('js-load--step3');
    }

    function startAnimation() {
        // Let's remove the eventlistener. We've heard what we've been listening for. We cover our ears for now :-)
        pageLoadElm.removeEventListener('transitionend', startAnimation);

        const logoLineBCR = logoLine.getBoundingClientRect();
        const logoLineHeight = logoLineBCR.height;
        const logoLineTop = logoLineBCR.top;
        const logoLineBottom = windowHeight - logoLineTop - logoLineHeight;
        const logoLineTranslate = (logoLineBottom - logoLineTop) / 2;
        const logoLineScale = windowHeight / logoLineHeight;

        // This has to be on the white boxes instead... The line is gone before the white boxes is...
        // To make this work, we have to use elements instead of pseudo-elements because transitionend is not suported on pseudo elements in all browsers we need to support.
        logoLine.addEventListener('transitionend', startContentAnimation);
        logoLine.style.transform = `translateY(${logoLineTranslate}px) scaleY(${logoLineScale})`;
        document.body.classList.add('js-load--step2');
    }

    if (pageLoadElm && logoLine) {
        pageLoadElm.addEventListener('transitionend',startAnimation);
    }
}